
import React, { useContext, useEffect, useState } from 'react';
import QrReader from 'react-qr-reader';
import { useHistory, Link, useParams } from 'react-router-dom';
import useDb from 'hooks/useDb';

// ------ material-ui components ------
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';


const ScanQr = ({ setAppBarContent }) => {
  const [qrData] = useState('');
  const history = useHistory();
  const db = useDb();
  const map = {
    "smartThermostat_scanSerial1": "smartThermostat_serial1",
    "smartThermostat_scanSerial2": "smartThermostat_serial2",
  }
  const { appointmentId, type, version, fieldName } = useParams();

  const cacheSerialNumber = async (serialNumber) => {
    return db.forms
      .where({
        appointmentId,
        type,
        version,
      })
      .modify({ [map[fieldName]]: serialNumber })
      .then(res => {
        history.goBack()
      })
  .catch(err => console.log(err))
  };

  const handleScan = data => {
    if (data) {
      const [_, __, ___, serialGroup] = data.split(':')
      const [serialNumber] = serialGroup.split('$')
      cacheSerialNumber(serialNumber)
      // TODO: check Dexie for existing customer and add if it doesn't exist

    }
  }

  const handleError = error => {
    console.log(error)
    alert(error)
  }

  return (
    <Container >
      {!!history.location.state && <Button component={Link} to={history.location.state.prevPath} variant='contained'>Back</Button>}
      <QrReader
        delay={500}
        resolution={300}
        onScan={handleScan}
        onError={handleError}
        style={{ width: '100%' }}
      />
      <div>QR DATA: {qrData}</div>
    </Container>
  )
}

export default ScanQr;